import { LatLngModel } from "front-end/services/geolocation/models/lat-lng.model";
import { filter, Observable, of, pairwise, startWith, switchMap, take } from "rxjs";

class UserGeoLocationService {
    public getInitialLocation(): Observable<LatLngModel> {
        return  this.getPermissionState() // handle olny initial request
            .pipe(
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                switchMap(([previousState, currentState]) => {
                    if (currentState === "prompt" ||currentState === "denied") {  // access denied
                        return of(null);
                    }

                    if (currentState === "granted") {
                        return this.getCurrentLocation(); // silent request
                    }
                }),
                take(1)
            );
    }

    public watchCurrentLocation(): Observable<LatLngModel> {
        return this.getPermissionState() // handle permission changes
            .pipe(
                filter(([previousState, currentState]) => {
                    return currentState === "prompt" // handle permissions change via chrome://settings/content/location || initial page request without any permissions
                    || ((previousState === "denied" && currentState === "granted") || (previousState === "granted" && currentState === "denied")); // handling permissions change via query string bar
                }),
                switchMap(() => this.getCurrentLocation())
            );
    }

    private getPermissionState(): Observable<[PermissionState, PermissionState]> {
        const permissionsObservable = new Observable<PermissionState>(observer => {
            if(this.isBrowserSupportGeolocation()) {
                void navigator.permissions
                    .query({ name: "geolocation" })
                    .then((initialStatus) => {
                        observer.next(initialStatus.state);

                        initialStatus.onchange = (changeEvent: Event): void => {
                            const currentStatus = changeEvent.target as PermissionStatus;
                            observer.next(currentStatus.state);
                        };
                    });
            } else {
                observer.next(null);
                observer.complete();
            }
        });

        return permissionsObservable
            .pipe(
                startWith(null), // emitting first empty value to fill-in the buffer
                pairwise()
            );
    }

    private getCurrentLocation(): Observable<LatLngModel> {
        const currentLocationObservable = new Observable<LatLngModel>(observer => {
            if(this.isBrowserSupportGeolocation()) {
                window.navigator.geolocation.getCurrentPosition(
                    (position) => {
                        observer.next(new LatLngModel(
                            position.coords.latitude,
                            position.coords.longitude
                        ));
                        observer.complete();
                    },
                    () => {
                        observer.next(null);
                        observer.complete();
                    }
                );
            } else {
                observer.next(null);
                observer.complete();
            }
        });

        return currentLocationObservable;
    }

    private isBrowserSupportGeolocation(): boolean {
        return !!navigator.geolocation;
    }
}

export const userGeoLocationService = new UserGeoLocationService();
